<template>
  <a class="label__link mod--delete w-inline-block">
    <v-icon v-if="loading">
      mdi-spin mdi-sync
    </v-icon>

    <img
      v-else
      src="/images/i-trash.svg"
      loading="lazy"
      alt=""
      class="label__link-img"
    >
  </a>
</template>

<script>
export default {
  name: 'LKIconTrash',
  props: {
    loading: Boolean,
  },
}
</script>
